module.exports = __webpack_public_path__ + "img/8_50.91540c3c.png";